import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderForwardTaxiTaxiDraft from "./billings-order-forward-taxi-taxi-draft";
import BillingsOrderForwardTaxiTaxiDraftParams from "./billings-order-forward-taxi-taxi-draft-params";

const useTaxiTaxiBillingDraft = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderForwardTaxiTaxiDraft | null>(null);

  const load = async (
    params: BillingsOrderForwardTaxiTaxiDraftParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderForwardTaxiTaxiBillingsDraft(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useTaxiTaxiBillingDraft;
